"use client";
import React, { useEffect, useState } from "react";
import { Collapse } from "antd";
import CommonImage from "@/components/common/image/CommonImage";
import "antd/dist/reset.css";
import {
  DownOutlined,
  MessageOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

import "./CustomCollapse.css";
import HomePageService from "@/services/api/HomeService";
import { useSelector } from "react-redux";
import SkeletonFAQSection from "@/components/common/skeletons/SkeletonFAQSection";

const FAQSection = ({faqs=[]}) => {
  const setting = useSelector((state) => state.setting.data);

  const items = faqs?.map((faq, index) => ({
    key: String(index + 1),
    label: (
      <div className="flex justify-between items-center w-full">
        <span className="text-left faq-question">{faq.question}</span>
      </div>
    ),
    children: <p className="text-gray-700">{faq.answer}</p>,
  }));

  return (
    <>
      {/* {loading ? (
        <SkeletonFAQSection />
      ) : ( */}
        <section className="faq_section section_padding">
          <div className="container">
            <div className="faq-card-wrap">
              <div className="content">
                <div className="faq-question-mark">
                  <CommonImage
                    src={"/images/home-page/faq-questions.avif"}
                    className="icon"
                    alt="Faq Icon"
                  />
                </div>
                <h2 className="main-title">
                  <span className="text-light">কোর্সটি</span> কেন করবে
                </h2>
                <p className="short-des">{setting?.faq_description}</p>
              </div>

              <div className="accordion">
                <Collapse
                  accordion
                  items={items}
                  expandIconPosition="end"
                  expandIcon={({ isActive }) => (
                    <DownOutlined rotate={isActive ? 180 : 0} />
                  )}
                  className="custom-collapse"
                />
              </div>
            </div>
          </div>
        </section>
      {/* )} */}
    </>
  );
};

export default FAQSection;
